import BroadcastPulseCheckModal from './BroadcastPulseCheckModal.component';

export default BroadcastPulseCheckModal;
